














import Vue from 'vue';

export default Vue.extend({
  name: 'SearchableZeroState',
  props: {
    objectType: {
      type: String,
      required: true,
    },
    searchString: {
      type: String,
      required: true,
    },
    mappedColumn: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    message() {
      const verb = this.mappedColumn ? 'mapped' : 'available';
      const searchedField = this.lowerObjectType === 'people' ? 'their name' : 'the title';

      if (this.searchString === '') {
        return `It seems there are no ${this.lowerObjectType} ${verb}.`;
      } else {
        return `It seems there are no ${this.lowerObjectType} with "${this.searchString}" in ${searchedField}. Please update your search term.`;
      }
    },
    lowerObjectType() {
      return this.objectType.toLowerCase();
    },
  },
});
